module.exports = __webpack_public_path__ + "2032a72eb77df8bbffff13769eb7d691.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau05.jpg
// module id = 520
// module chunks = 0